<uic-header-menu #headermenu name="menu" variant="primary" [class.is-impersonated]="isImpersonated()">
  <!-- Apps Menu Button-->
  <uic-header-menu-item
    name="menu-item-app-switcher"
    icon="uic:appswitcher"
    icon-only="true"
    class="app-switcher"
    (click)="openMenu(MenuType.AppMenu)"
  >
  </uic-header-menu-item>
  @if (selectedMenu === MenuType.AppMenu) {
    <div class="relative flex h-full">
      <app-app-menu class="absolute left-[-4.540rem] top-[36px] z-50"
                    (routerLinkActivated)="clearMenuSelection()"></app-app-menu>
    </div>
  }

  <!-- Expander -->
  <div class="flex-grow"></div>

  <!-- Administration Menu Button-->
  <uic-header-menu-item
    name="menu-item-administration"
    icon="uic:settings"
    icon-only="true"
    (click)="openMenu(MenuType.AdministrationMenu)"
  >
  </uic-header-menu-item>
  @if (selectedMenu === MenuType.AdministrationMenu) {
    <div class="relative flex h-full">
      <app-administration-menu class="absolute right-0 top-[36px] z-50" (routerLinkActivated)="clearMenuSelection()"/>
    </div>
  }

  <!-- Information Menu Button-->
  <uic-header-menu-item
    name="menu-item-information"
    icon="uic:help"
    icon-only="true"
    (click)="openMenu(MenuType.InfoMenu)"
  >
  </uic-header-menu-item>
  @if (selectedMenu === MenuType.InfoMenu) {
    <div class="relative flex h-full">
      <app-info-menu class="absolute right-0 top-[36px] z-50" (routerLinkActivated)="clearMenuSelection()"/>
    </div>
  }

  <!-- Profile Menu Button-->
  <uic-header-menu-item
    name="menu-item-profile"
    trailing-icon="uic:user"
    (click)="openMenu(MenuType.UserMenu)">
    <vicp-header-profile-user-info></vicp-header-profile-user-info>
  </uic-header-menu-item>

  <!-- Logout Button-->
  <uic-header-menu-item
    name="menu-item-logout"
    (click)="clickLogout()">
    <span class="material-icons">power_settings_new</span>
  </uic-header-menu-item>
</uic-header-menu>
